/** 거래처·입금·단가 관리 창 (탭) · 입금 내역 칸 · 거래처 입력 칸 — 견적서 창과 공용 */
import React, { useEffect, useState } from 'react';
import { Customer, Receivable, Deposit, PriceData, SubItem, listCustomers, saveCustomer, listReceivables, listDeposits, addDeposit, deleteDeposit,
  fetchPrices, savePrices, saveSubItem, saveQuoteSettings, saveAccounts, BankAccount, errMsg } from '../utils/api';
import { MATERIAL_SPECS } from '../utils/materialSpecs';
import { MaterialType } from '../types';
import { jobOf } from './WorkBoard';

import { overlay, box, head, xBtn, inp, btn, th, td, num, chip, C } from './ui';
export { overlay, box, head, xBtn, inp, btn, th, td, num } from './ui';
export const won = (n: number | null | undefined) => Math.round(n || 0).toLocaleString('ko-KR');
const today = () => new Date(Date.now() + 9 * 3600e3).toISOString().slice(0, 10);
const MATS = Object.keys(MATERIAL_SPECS) as MaterialType[];
const THICKS = [75, 100, 125, 150];

/** 입금 내역 + 입금 등록 (견적 하나) */
export const DepositPanel: React.FC<{ estiNo: string; billed: number; onChanged?: () => void }> = ({ estiNo, billed, onChanged }) => {
  const [rows, setRows] = useState<Deposit[] | null>(null);
  const [f, setF] = useState({ inDt: today(), amount: '', memo: '' });
  const [err, setErr] = useState<string | null>(null);
  const load = () => listDeposits(estiNo).then(r => setRows(r.data)).catch(e => setErr(errMsg(e)));
  useEffect(() => { load(); }, [estiNo]); // eslint-disable-line react-hooks/exhaustive-deps
  const paid = (rows || []).reduce((a, r) => a + r.AMOUNT, 0);
  const add = async () => {
    try { await addDeposit(estiNo, { inDt: f.inDt, amount: Number(f.amount.replace(/,/g, '')), memo: f.memo }); setF({ ...f, amount: '', memo: '' }); setErr(null); await load(); onChanged?.(); }
    catch (e) { setErr(errMsg(e)); }
  };
  const del = async (d: Deposit) => {
    if (!window.confirm(`${d.IN_DT} ${won(d.AMOUNT)}원 입금 내역을 지울까요?`)) return;
    try { await deleteDeposit(d.DEPO_ID); await load(); onChanged?.(); } catch (e) { setErr(errMsg(e)); }
  };
  return (
    <div style={{ background: C.bg, borderRadius: 14, padding: 14, fontSize: 13 }}>
      <div style={{ display: 'flex', gap: 16, marginBottom: 6 }}>
        <span>청구 <b>{won(billed)}</b></span><span>입금 <b style={{ color: C.green }}>{won(paid)}</b></span>
        <span>미수 <b style={{ color: billed - paid > 0 ? C.red : C.sub }}>{won(billed - paid)}</b></span>
      </div>
      {rows && rows.length > 0 && (
        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 6 }}><tbody>
          {rows.map(d => <tr key={d.DEPO_ID}><td style={td}>{d.IN_DT}</td><td style={num}>{won(d.AMOUNT)}</td><td style={{ ...td, color: '#666' }}>{d.MEMO}</td>
            <td style={{ ...td, color: '#999', fontSize: 11 }}>{d.REG_ID}</td>
            <td style={{ ...td, textAlign: 'right' }}><button onClick={() => del(d)} style={{ ...btn('#C62828', false), padding: '2px 8px', fontSize: 11 }}>삭제</button></td></tr>)}
        </tbody></table>
      )}
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        <input type="date" value={f.inDt} onChange={e => setF({ ...f, inDt: e.target.value })} style={inp} />
        <input value={f.amount} onChange={e => setF({ ...f, amount: e.target.value })} placeholder={`입금액 (미수 ${won(Math.max(0, billed - paid))})`} inputMode="numeric" style={{ ...inp, width: 170 }} />
        <input value={f.memo} onChange={e => setF({ ...f, memo: e.target.value })} placeholder="메모 (입금자명 등)" style={{ ...inp, flex: 1, minWidth: 120 }} />
        <button onClick={add} style={btn(C.green)}>입금 등록</button>
      </div>
      <div style={{ fontSize: 11, color: '#888', marginTop: 4 }}>환불·조정은 음수 금액으로 등록합니다.</div>
      {err && <div style={{ color: C.red, marginTop: 4 }}>⚠ {err}</div>}
    </div>
  );
};

/** 거래처 입력 칸 (새로 만들기·고치기) */
export const CustomerForm: React.FC<{ value?: Partial<Customer>; onSaved: (id: number) => void; onCancel: () => void }> = ({ value, onSaved, onCancel }) => {
  const [c, setC] = useState<Partial<Customer>>(value || { USE_YN: 'Y' });
  const [err, setErr] = useState<string | null>(null);
  const set = (k: keyof Customer) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setC({ ...c, [k]: e.target.value });
  const save = async () => {
    try { const r = await saveCustomer(c); onSaved(r.data.custId); } catch (e) { setErr(errMsg(e)); }
  };
  const F = (k: keyof Customer, label: string, w = '1fr') => (
    <label style={{ fontSize: 11, color: '#555', gridColumn: w === 'full' ? '1 / -1' : undefined }}>{label}
      <input value={(c[k] as string) || ''} onChange={set(k)} style={{ ...inp, width: '100%', marginTop: 2 }} /></label>);
  return (
    <div style={{ background: C.bg, borderRadius: 14, padding: 16 }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 8 }}>
        {F('CUST_NM', '거래처명 *')}{F('BIZ_NO', '사업자번호')}{F('CEO_NM', '대표자')}{F('MGR_NM', '담당자')}
        {F('TEL', '전화')}{F('HP', '휴대폰')}{F('FAX', '팩스')}{F('EMAIL', '이메일')}
        {F('ADDR', '주소', 'full')}{F('MEMO', '메모', 'full')}
      </div>
      {c.CUST_ID && <label style={{ display: 'inline-flex', gap: 4, alignItems: 'center', fontSize: 12, marginTop: 8 }}>
        <input type="checkbox" checked={c.USE_YN === 'N'} onChange={e => setC({ ...c, USE_YN: e.target.checked ? 'N' : 'Y' })} /> 거래 중지 (목록에서 숨김)</label>}
      {err && <div style={{ color: C.red, fontSize: 13, marginTop: 6 }}>⚠ {err}</div>}
      <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end', marginTop: 8 }}>
        <button onClick={onCancel} style={btn('#757575', false)}>취소</button>
        <button onClick={save} style={btn('#1976D2')}>저장</button>
      </div>
    </div>
  );
};

type Tab = 'recv' | 'cust' | 'price' | 'items' | 'setting';

/** 거래처·입금·단가 관리 */
export const BizDialog: React.FC<{ manager: boolean; onClose: () => void; onOpenEstimate?: (no: string) => void }> = ({ manager, onClose, onOpenEstimate }) => {
  const [tab, setTab] = useState<Tab>('recv');
  const [cust, setCust] = useState<Customer | null>(null); // 미수 탭 거래처 거르기
  const tabs: [Tab, string][] = [['recv', '입금·미수'], ['cust', '거래처'], ...(manager ? [['price', '단가표'], ['items', '부자재 품목'], ['setting', '견적서 설정']] as [Tab, string][] : [])];
  return (
    <div style={overlay} onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <div style={{ ...box, maxWidth: 980, height: '90vh' }}>
        <div style={head()}><b>거래처 · 입금 · 단가</b><button onClick={onClose} style={xBtn}>✕</button></div>
        <div style={{ display: 'flex', gap: 6, padding: '4px 24px 12px', flexWrap: 'wrap' }}>
          {tabs.map(([k, l]) => <button key={k} onClick={() => setTab(k)} style={chip(tab === k)}>{l}</button>)}
          {!manager && <span style={{ fontSize: 12, color: '#888', alignSelf: 'center' }}>단가표·품목은 회사 관리자가 바꿉니다</span>}
        </div>
        <div style={{ flex: 1, overflow: 'auto', padding: '0 24px 20px' }}>
          {tab === 'recv' && <ReceivableTab cust={cust} onClearCust={() => setCust(null)} onOpenEstimate={onOpenEstimate} />}
          {tab === 'cust' && <CustomerTab onShowRecv={c => { setCust(c); setTab('recv'); }} />}
          {tab === 'price' && <PriceTab />}
          {tab === 'items' && <ItemTab />}
          {tab === 'setting' && <SettingTab />}
        </div>
      </div>
    </div>
  );
};

const ReceivableTab: React.FC<{ cust: Customer | null; onClearCust: () => void; onOpenEstimate?: (no: string) => void }> = ({ cust, onClearCust, onOpenEstimate }) => {
  const [q, setQ] = useState('');
  const [unpaid, setUnpaid] = useState(true);
  const [rows, setRows] = useState<Receivable[] | null>(null);
  const [open, setOpen] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const load = () => listReceivables({ q, cust: cust?.CUST_ID, unpaid }).then(r => { setRows(r.data); setErr(null); }).catch(e => setErr(errMsg(e)));
  useEffect(() => { load(); }, [unpaid, cust]); // eslint-disable-line react-hooks/exhaustive-deps
  const sum = (k: 'BILLED' | 'PAID') => (rows || []).reduce((a, r) => a + r[k], 0);
  return (<>
    <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8, flexWrap: 'wrap' }}>
      <input value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => e.key === 'Enter' && load()} placeholder="견적번호·현장·거래처" style={{ ...inp, width: 220 }} />
      <button onClick={load} style={btn('#1976D2')}>검색</button>
      <label style={{ fontSize: 13, display: 'flex', gap: 4, alignItems: 'center' }}><input type="checkbox" checked={unpaid} onChange={e => setUnpaid(e.target.checked)} /> 미수 남은 확정 견적만</label>
      {cust && <span style={{ fontSize: 13, background: C.orangeWeak, color: C.orange, padding: '4px 12px', borderRadius: 999 }}>거래처: <b>{cust.CUST_NM}</b> <button onClick={onClearCust} style={{ border: 'none', background: 'none', cursor: 'pointer' }}>✕</button></span>}
      <span style={{ marginLeft: 'auto', fontSize: 13 }}>청구 <b>{won(sum('BILLED'))}</b> · 입금 <b>{won(sum('PAID'))}</b> · 미수 <b style={{ color: C.red }}>{won(sum('BILLED') - sum('PAID'))}</b></span>
    </div>
    {err && <div style={{ color: C.red, fontSize: 13 }}>⚠ {err}</div>}
    <div style={{ fontSize: 11, color: '#888', marginBottom: 6 }}>청구액 = 확정된 견적의 공급가액 + 부가세 (확정 전 견적은 견적액만 보이고 미수에 넣지 않음)</div>
    {rows === null ? <div style={{ color: '#888' }}>불러오는 중…</div> : rows.length === 0 ? <div style={{ color: '#888' }}>{unpaid ? '미수 남은 견적이 없습니다' : '견적서를 저장한 견적이 없습니다'}</div> : (
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead><tr>{['견적번호', '거래처', '현장', '상태', '견적액', '청구', '입금', '미수', ''].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
        <tbody>{rows.map(r => (
          <React.Fragment key={r.ESTI_NO}>
            <tr onClick={() => setOpen(open === r.ESTI_NO ? null : r.ESTI_NO)} style={{ cursor: 'pointer', background: open === r.ESTI_NO ? C.blueWeak : undefined }}>
              <td style={{ ...td, fontVariantNumeric: 'tabular-nums' }}>{r.ESTI_NO}</td><td style={td}>{r.CUST_NM || <span style={{ color: '#aaa' }}>-</span>}</td>
              <td style={td}>{r.SITE_NM}</td><td style={{ ...td, color: jobOf(r.JOB_STATE).color, fontWeight: 'bold' }}>{jobOf(r.JOB_STATE).label}</td>
              <td style={num}>{won(r.QUOTED)}</td><td style={num}>{won(r.BILLED)}</td><td style={{ ...num, color: C.green }}>{won(r.PAID)}</td>
              <td style={{ ...num, color: r.BILLED - r.PAID > 0 ? C.red : C.sub, fontWeight: 'bold' }}>{won(r.BILLED - r.PAID)}</td>
              <td style={{ ...td, textAlign: 'right' }}>{onOpenEstimate && <button onClick={e => { e.stopPropagation(); onOpenEstimate(r.ESTI_NO); }} style={{ ...btn('#1976D2', false), padding: '2px 8px', fontSize: 11 }}>도면 열기</button>}</td>
            </tr>
            {open === r.ESTI_NO && <tr><td colSpan={9} style={{ padding: 8 }}><DepositPanel estiNo={r.ESTI_NO} billed={r.BILLED || r.QUOTED} onChanged={load} /></td></tr>}
          </React.Fragment>
        ))}</tbody>
      </table>
    )}
  </>);
};

const CustomerTab: React.FC<{ onShowRecv: (c: Customer) => void }> = ({ onShowRecv }) => {
  const [q, setQ] = useState('');
  const [all, setAll] = useState(false);
  const [rows, setRows] = useState<Customer[] | null>(null);
  const [edit, setEdit] = useState<Partial<Customer> | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const load = () => listCustomers(q, all).then(r => { setRows(r.data); setErr(null); }).catch(e => setErr(errMsg(e)));
  useEffect(() => { load(); }, [all]); // eslint-disable-line react-hooks/exhaustive-deps
  return (<>
    <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8, flexWrap: 'wrap' }}>
      <input value={q} onChange={e => setQ(e.target.value)} onKeyDown={e => e.key === 'Enter' && load()} placeholder="거래처명·담당·전화·사업자번호" style={{ ...inp, width: 240 }} />
      <button onClick={load} style={btn('#1976D2')}>검색</button>
      <label style={{ fontSize: 13, display: 'flex', gap: 4, alignItems: 'center' }}><input type="checkbox" checked={all} onChange={e => setAll(e.target.checked)} /> 거래 중지 포함</label>
      <button onClick={() => setEdit({ USE_YN: 'Y' })} style={{ ...btn(C.green), marginLeft: 'auto' }}>+ 새 거래처</button>
    </div>
    {edit && <div style={{ marginBottom: 10 }}><CustomerForm key={edit.CUST_ID ?? 'new'} value={edit} onCancel={() => setEdit(null)} onSaved={() => { setEdit(null); load(); }} /></div>}
    {err && <div style={{ color: C.red, fontSize: 13 }}>⚠ {err}</div>}
    {rows === null ? <div style={{ color: '#888' }}>불러오는 중…</div> : rows.length === 0 ? <div style={{ color: '#888' }}>거래처가 없습니다 — [+ 새 거래처]로 추가하세요</div> : (
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead><tr>{['거래처', '담당', '연락처', '견적', '청구', '입금', '미수', ''].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
        <tbody>{rows.map(c => {
          const bal = (c.BILLED || 0) - (c.PAID || 0);
          return (
            <tr key={c.CUST_ID} style={{ opacity: c.USE_YN === 'N' ? 0.5 : 1 }}>
              <td style={td}><b>{c.CUST_NM}</b>{c.USE_YN === 'N' && ' (중지)'}<div style={{ fontSize: 11, color: '#888' }}>{c.ADDR}</div></td>
              <td style={td}>{c.MGR_NM || c.CEO_NM}</td><td style={td}>{c.HP || c.TEL}</td><td style={num}>{c.EST_CNT}</td>
              <td style={num}>{won(c.BILLED)}</td><td style={{ ...num, color: C.green }}>{won(c.PAID)}</td>
              <td style={{ ...num, color: bal > 0 ? C.red : C.sub, fontWeight: 'bold' }}>{won(bal)}</td>
              <td style={{ ...td, textAlign: 'right', whiteSpace: 'nowrap' }}>
                <button onClick={() => onShowRecv(c)} style={{ ...btn('#1976D2', false), padding: '2px 8px', fontSize: 11 }}>입금·미수</button>{' '}
                <button onClick={() => setEdit(c)} style={{ ...btn('#757575', false), padding: '2px 8px', fontSize: 11 }}>수정</button>
              </td>
            </tr>
          );
        })}</tbody>
      </table>
    )}
  </>);
};

/** 단가표 — 패널 재질×두께(㎡당), 문 폭×두께(개당), 재질별 문 할증 */
const PriceTab: React.FC = () => {
  const [p, setP] = useState<PriceData | null>(null);
  const [msg, setMsg] = useState<{ ok: boolean; t: string } | null>(null);
  const [newW, setNewW] = useState('');
  useEffect(() => { fetchPrices().then(r => setP(r.data)).catch(e => setMsg({ ok: false, t: errMsg(e) })); }, []);
  if (!p) return <div style={{ color: msg ? '#C62828' : '#888' }}>{msg?.t ?? '불러오는 중…'}</div>;
  const setPanel = (m: string, t: number, v: string) => setP({ ...p, panel: { ...p.panel, [m]: { ...p.panel[m], [t]: Number(v.replace(/,/g, '')) || 0 } } });
  const setDoor = (w: string, t: number, v: string) => setP({ ...p, door: { ...p.door, [w]: { ...p.door[w], [t]: Number(v.replace(/,/g, '')) || 0 } } });
  const widths = Object.keys(p.door).sort((a, b) => +a - +b);
  const cell = (v: number | undefined, on: (s: string) => void) => (
    <td style={{ ...td, padding: 3 }}><input value={v == null ? '' : won(v)} onChange={e => on(e.target.value)} inputMode="numeric" style={{ ...inp, width: 100, textAlign: 'right' }} /></td>);
  const save = async () => {
    try { await savePrices({ panel: p.panel, door: p.door, doorAdd: p.doorAdd }); setMsg({ ok: true, t: '단가표를 저장했습니다 — 새로 여는 견적서부터 적용' }); }
    catch (e) { setMsg({ ok: false, t: errMsg(e) }); }
  };
  return (<div style={{ fontSize: 13 }}>
    <h4 style={{ margin: '4px 0 8px', fontSize: 15, color: C.text }}>패널 단가 (㎡당, 원)</h4>
    <table style={{ borderCollapse: 'collapse' }}><thead><tr><th style={th}>재질</th>{THICKS.map(t => <th key={t} style={th}>{t}T</th>)}</tr></thead>
      <tbody>{MATS.map(m => <tr key={m}><td style={td}>{MATERIAL_SPECS[m].label}</td>{THICKS.map(t => <React.Fragment key={t}>{cell(p.panel[m]?.[t], v => setPanel(m, t, v))}</React.Fragment>)}</tr>)}</tbody></table>
    <h4 style={{ margin: '20px 0 8px', fontSize: 15, color: C.text }}>문 단가 (개당, 원) — 문 폭 이상인 가장 작은 폭의 단가를 씁니다</h4>
    <table style={{ borderCollapse: 'collapse' }}><thead><tr><th style={th}>문 폭</th>{THICKS.map(t => <th key={t} style={th}>{t}T</th>)}<th style={th}></th></tr></thead>
      <tbody>{widths.map(w => <tr key={w}><td style={td}>{w}</td>{THICKS.map(t => <React.Fragment key={t}>{cell(p.door[w]?.[t], v => setDoor(w, t, v))}</React.Fragment>)}
        <td style={td}><button onClick={() => { const d = { ...p.door }; delete d[w]; setP({ ...p, door: d }); }} style={{ ...btn('#C62828', false), padding: '2px 8px', fontSize: 11 }}>빼기</button></td></tr>)}
        <tr><td style={td} colSpan={6}><input value={newW} onChange={e => setNewW(e.target.value)} placeholder="문 폭 (mm)" inputMode="numeric" style={{ ...inp, width: 110 }} />{' '}
          <button onClick={() => { const w = String(Math.round(Number(newW))); if (+w >= 300 && !p.door[w]) { setP({ ...p, door: { ...p.door, [w]: {} } }); setNewW(''); } }} style={btn('#1976D2', false)}>+ 폭 추가</button></td></tr>
      </tbody></table>
    <h4 style={{ margin: '20px 0 8px', fontSize: 15, color: C.text }}>문 재질 할증 (개당, 원)</h4>
    <table style={{ borderCollapse: 'collapse' }}><tbody><tr>{MATS.map(m => <React.Fragment key={m}><td style={td}>{MATERIAL_SPECS[m].label}</td>
      {cell(p.doorAdd[m], v => setP({ ...p, doorAdd: { ...p.doorAdd, [m]: Number(v.replace(/,/g, '')) || 0 } }))}</React.Fragment>)}</tr></tbody></table>
    <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 14 }}>
      <button onClick={save} style={btn('#1976D2')}>단가표 저장</button>
      {msg && <span style={{ color: msg.ok ? C.green : '#C62828' }}>{msg.t}</span>}
    </div>
    <div style={{ fontSize: 11, color: '#888', marginTop: 6 }}>기본값은 이전 시스템의 마지막 단가표(2015년 11월~)입니다.</div>
  </div>);
};

/** 부자재 품목 — 줄마다 저장, 지우지 않고 숨김 */
const ItemTab: React.FC = () => {
  const [items, setItems] = useState<Partial<SubItem>[] | null>(null);
  const [msg, setMsg] = useState<{ ok: boolean; t: string } | null>(null);
  const load = () => fetchPrices().then(r => setItems(r.data.items)).catch(e => setMsg({ ok: false, t: errMsg(e) }));
  useEffect(() => { load(); }, []);
  if (!items) return <div style={{ color: msg ? '#C62828' : '#888' }}>{msg?.t ?? '불러오는 중…'}</div>;
  const set = (i: number, k: keyof SubItem, v: any) => setItems(items.map((it, j) => (j === i ? { ...it, [k]: v, _dirty: true } as any : it)));
  const save = async (it: Partial<SubItem>) => {
    try { await saveSubItem(it); setMsg({ ok: true, t: `${it.ITEM_NM} 저장` }); await load(); } catch (e) { setMsg({ ok: false, t: errMsg(e) }); }
  };
  return (<div style={{ fontSize: 13 }}>
    <table style={{ borderCollapse: 'collapse' }}>
      <thead><tr>{['품목명', '규격', '단위', '단가(원)', '순서', '사용', ''].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
      <tbody>{items.map((it, i) => (
        <tr key={it.ITEM_ID ?? `n${i}`} style={{ opacity: it.USE_YN === 'N' ? 0.5 : 1 }}>
          <td style={{ ...td, padding: 3 }}><input value={it.ITEM_NM || ''} onChange={e => set(i, 'ITEM_NM', e.target.value)} style={{ ...inp, width: 150 }} /></td>
          <td style={{ ...td, padding: 3 }}><input value={it.SPEC || ''} onChange={e => set(i, 'SPEC', e.target.value)} style={{ ...inp, width: 110 }} /></td>
          <td style={{ ...td, padding: 3 }}><input value={it.UNIT || ''} onChange={e => set(i, 'UNIT', e.target.value)} style={{ ...inp, width: 50 }} /></td>
          <td style={{ ...td, padding: 3 }}><input value={won(it.UNIT_COST)} onChange={e => set(i, 'UNIT_COST', Number(e.target.value.replace(/,/g, '')) || 0)} inputMode="numeric" style={{ ...inp, width: 100, textAlign: 'right' }} /></td>
          <td style={{ ...td, padding: 3 }}><input value={it.SORT_SEQ ?? ''} onChange={e => set(i, 'SORT_SEQ', Number(e.target.value) || 0)} style={{ ...inp, width: 46 }} /></td>
          <td style={td}><input type="checkbox" checked={it.USE_YN !== 'N'} onChange={e => set(i, 'USE_YN', e.target.checked ? 'Y' : 'N')} /></td>
          <td style={td}>{(it as any)._dirty && <button onClick={() => save(it)} style={{ ...btn('#1976D2'), padding: '3px 10px' }}>저장</button>}</td>
        </tr>
      ))}</tbody>
    </table>
    <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 10 }}>
      <button onClick={() => setItems([...items, { ITEM_NM: '', UNIT: '개', UNIT_COST: 0, USE_YN: 'Y', _dirty: true } as any])} style={btn(C.green, false)}>+ 품목 추가</button>
      {msg && <span style={{ color: msg.ok ? C.green : '#C62828' }}>{msg.t}</span>}
    </div>
    <div style={{ fontSize: 11, color: '#888', marginTop: 6 }}>쓰지 않는 품목은 [사용]을 끄면 견적서 품목 목록에서 빠집니다 (이미 넣은 견적은 그대로).</div>
  </div>);
};

/** 견적서 설정 — 공급자 칸(가입 정보) 전화·팩스·주소, 특약사항 */
const SettingTab: React.FC = () => {
  const [f, setF] = useState<{ TEL: string; FAX: string; ADDR: string; QUOTE_TERMS: string } | null>(null);
  const [co, setCo] = useState<PriceData['company'] | null>(null);
  const [msg, setMsg] = useState<{ ok: boolean; t: string } | null>(null);
  useEffect(() => {
    fetchPrices().then(r => { const c = r.data.company; setCo(c); setF({ TEL: c.TEL || '', FAX: c.FAX || '', ADDR: c.ADDR || '', QUOTE_TERMS: c.QUOTE_TERMS || '' }); })
      .catch(e => setMsg({ ok: false, t: errMsg(e) }));
  }, []);
  if (!f || !co) return <div style={{ color: msg ? '#C62828' : '#888' }}>{msg?.t ?? '불러오는 중…'}</div>;
  const save = async () => { try { await saveQuoteSettings(f); setMsg({ ok: true, t: '저장했습니다' }); } catch (e) { setMsg({ ok: false, t: errMsg(e) }); } };
  const lab: React.CSSProperties = { display: 'block', fontSize: 12, color: '#555', marginTop: 10 };
  return (<div style={{ fontSize: 13, maxWidth: 620 }}>
    <div style={{ background: C.bg, borderRadius: 12, padding: 12 }}>견적서 공급자: <b>{co.COMP_NM}</b> · 사업자 {co.BIZ_NO} · 대표 {co.CEO_NM}
      <div style={{ fontSize: 11, color: '#888' }}>상호·사업자번호·대표자는 가입 정보입니다 (바꾸려면 운영사에 문의)</div></div>
    <div style={{ display: 'flex', gap: 10 }}>
      <label style={{ ...lab, flex: 1 }}>전화<input value={f.TEL} onChange={e => setF({ ...f, TEL: e.target.value })} style={{ ...inp, width: '100%' }} /></label>
      <label style={{ ...lab, flex: 1 }}>팩스<input value={f.FAX} onChange={e => setF({ ...f, FAX: e.target.value })} style={{ ...inp, width: '100%' }} /></label>
    </div>
    <label style={lab}>주소<input value={f.ADDR} onChange={e => setF({ ...f, ADDR: e.target.value })} style={{ ...inp, width: '100%' }} /></label>
    <label style={lab}>특약사항 (견적서 아래에 인쇄)<textarea value={f.QUOTE_TERMS} onChange={e => setF({ ...f, QUOTE_TERMS: e.target.value })} rows={6} style={{ ...inp, height: 'auto', padding: '10px 12px', lineHeight: 1.5, width: '100%', fontFamily: 'inherit' }} /></label>
    <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 10 }}>
      <button onClick={save} style={btn('#1976D2')}>저장</button>{msg && <span style={{ color: msg.ok ? C.green : '#C62828' }}>{msg.t}</span>}
    </div>
    <AccountSection />
  </div>);
};

/** 입금 계좌 — 견적서에 찍힘 (견적마다 고를 수 있고, 안 고르면 기본 계좌). 이전 시스템 '입금계좌관리' */
const AccountSection: React.FC = () => {
  const [list, setList] = useState<BankAccount[] | null>(null);
  const [msg, setMsg] = useState<{ ok: boolean; t: string } | null>(null);
  const load = () => fetchPrices().then(r => setList(r.data.accounts.filter(a => a.USE_YN !== 'N'))).catch(e => setMsg({ ok: false, t: errMsg(e) }));
  useEffect(() => { load(); }, []);
  if (!list) return null;
  const set = (i: number, k: keyof BankAccount, v: string) => { setMsg(null); setList(list.map((a, j) => (j === i ? { ...a, [k]: v } : k === 'DEFAULT_YN' ? { ...a, DEFAULT_YN: 'N' } : a))); };
  const save = async () => {
    try { await saveAccounts(list); setMsg({ ok: true, t: '입금 계좌를 저장했습니다' }); await load(); } catch (e) { setMsg({ ok: false, t: errMsg(e) }); }
  };
  return (<div style={{ marginTop: 24 }}>
    <div style={{ fontSize: 15, fontWeight: 700, color: C.text }}>입금 계좌</div>
    <div style={{ fontSize: 12, color: '#888', margin: '2px 0 8px' }}>견적서 아래에 「입금 계좌」로 인쇄됩니다. 견적서 창에서 견적마다 고를 수 있고, 고르지 않으면 기본 계좌가 찍힙니다.</div>
    {list.length === 0 && <div style={{ color: '#888', margin: '6px 0' }}>등록된 계좌가 없습니다</div>}
    {list.map((a, i) => (
      <div key={a.ACC_ID ?? `n${i}`} style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 6, flexWrap: 'wrap' }}>
        <input value={a.BANK_NM} onChange={e => set(i, 'BANK_NM', e.target.value)} placeholder="은행 (예: 국민은행)" style={{ ...inp, width: 130 }} />
        <input value={a.ACC_NO} onChange={e => set(i, 'ACC_NO', e.target.value)} placeholder="계좌번호" style={{ ...inp, width: 190 }} />
        <input value={a.HOLDER || ''} onChange={e => set(i, 'HOLDER', e.target.value)} placeholder="예금주" style={{ ...inp, width: 140 }} />
        <label style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>
          <input type="radio" name="defacc" checked={a.DEFAULT_YN === 'Y'} onChange={() => set(i, 'DEFAULT_YN', 'Y')} />기본</label>
        <button onClick={() => { setMsg(null); setList(list.filter((_, j) => j !== i)); }} style={{ ...btn('#F04452', false), height: 32, padding: '0 10px' }}>빼기</button>
      </div>
    ))}
    <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 8 }}>
      <button onClick={() => setList([...list, { BANK_NM: '', ACC_NO: '', HOLDER: '', DEFAULT_YN: list.length ? 'N' : 'Y' }])} style={btn(C.green, false)}>+ 계좌 추가</button>
      <button onClick={save} style={btn('#1976D2')}>계좌 저장</button>
      {msg && <span style={{ color: msg.ok ? C.green : '#C62828' }}>{msg.t}</span>}
    </div>
    <div style={{ fontSize: 11, color: '#888', marginTop: 6 }}>뺀 계좌는 목록에서만 사라지고, 그 계좌로 만든 예전 견적서에는 그대로 남습니다.</div>
  </div>);
};
